import React from "react"
import Statistic from "./statistic"

import styles from "./results.module.scss"

export interface Statistic {
  title: string
  description: string
}

interface Props {
  summary: {
    childMarkdownRemark: {
      html: string
    }
  }
  statistics: Statistic[]
  additional_info: Array<{ additionalInfoText: string }>
}

export default function Results({
  summary,
  statistics,
  additional_info,
}: Props) {
  return (
    <div className={styles.content}>
      <div className={styles.spacer} />
      <div className={styles.columns}>
        <div className={styles.column}>
          <h3 className={styles.heading}>The results</h3>
          <div
            className="content-block"
            dangerouslySetInnerHTML={{
              __html: summary.childMarkdownRemark.html,
            }}
          />
        </div>
        <div className={styles.column}>
          {/*spacer */}
          <p className={styles.heading}>&nbsp;</p>
          <div className={styles.nestedColumns}>
            {statistics.map((stat, i) => (
              <Statistic key={`stat-${i}`} {...stat} />
            ))}
          </div>
        </div>
      </div>
      {!!additional_info.length &&
        !!additional_info[0].additionalInfoText.length && (
          <ul className={styles.list}>
            <li>
              <h3 className={styles.heading}>Recognition</h3>
            </li>
            {additional_info.map((r, i) => (
              <li key={`r-${i}`}>
                <div
                  className="content-block"
                  dangerouslySetInnerHTML={{
                    __html: r.additionalInfoText,
                  }}
                />
              </li>
            ))}
          </ul>
        )}
    </div>
  )
}
